import { useTranslation } from 'react-i18next';
import { Mic, Square } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RecordButtonProps {
  state: 'idle' | 'recording' | 'disabled';
  onStart: () => void;
  onStop: () => void;
}

export function RecordButton({ state, onStart, onStop }: Readonly<RecordButtonProps>) {
  const { t } = useTranslation();

  const isRecording = state === 'recording';
  const isDisabled = state === 'disabled';

  const handleClick = () => {
    if (isRecording) {
      onStop();
    } else {
      onStart();
    }
  };

  const label = isRecording ? t('record.stop') : t('record.start');

  return (
    <div className="flex flex-col items-center gap-3">
      <button
        type="button"
        onClick={handleClick}
        disabled={isDisabled}
        aria-label={label}
        aria-pressed={isRecording}
        className={cn(
          'flex h-32 w-32 items-center justify-center rounded-full bg-destructive text-destructive-foreground shadow-md transition-all',
          isRecording && 'animate-pulse-record shadow-lg',
          isDisabled && 'cursor-not-allowed opacity-50',
          !isDisabled && !isRecording && 'cursor-pointer hover:bg-destructive/90',
        )}
      >
        {isRecording ? <Square className="h-10 w-10" /> : <Mic className="h-12 w-12" />}
      </button>
      <span className="text-sm font-medium text-muted-foreground">{label}</span>
    </div>
  );
}
